module.exports = __webpack_public_path__ + "static/lisa-grohs-a545c451c383538bcd1d132da9285190.jpg";